import React, { useEffect, useRef, useState } from "react";

import { connect } from "react-redux";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { sendAnalytics } from "../../../action/homeAction";
import { setRegPage } from "../../../action/action";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { CLICKED, CMSPath, EXIT, LOAD_ERROR } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import MiniLoader from "../../UI/MiniLoader";
import { scrollToTop } from "../../../JS/scrollToTop";
import Axios from "axios";
  import Loader from "../../UI/loader";






const Gha_WelcomePage = (props) => {
    const ref_ = useRef();
     

   

    const { t } = props;

    const handleJoinNowClick = () => props.handleNext(true)
    const handleLoginClick = () => props.handleNext(false)
    
  
    useEffect(() => {
        if (props.pageContent) {
 
            const joinButton1 = ref_.current.querySelector('#join-now-button1')
            const loginButton1 = ref_.current.querySelector('#login-button1')
            const joinButton2 = ref_.current.querySelector('#join-now-button2')
            const loginButton2 = ref_.current.querySelector('#login-button2')
            const rewardDetails= ref_.current.querySelectorAll('#GHALogin > div.rewards-details > div.drawer')

            if (joinButton1)
                joinButton1.addEventListener('click', handleJoinNowClick);

            if (joinButton2)
                joinButton2.addEventListener('click', handleJoinNowClick);

            if (loginButton1)
                loginButton1.addEventListener('click', handleLoginClick);

            if (loginButton2)
                loginButton2.addEventListener('click', handleLoginClick);

            if(rewardDetails && rewardDetails.length>0){
                rewardDetails.forEach(div => {
                    div.addEventListener('click', () => {
                         rewardDetails.forEach(d => d.classList.remove('open'));
                        
                         div.classList.add('open');
                    });
                });

            }




            return () => {
                if (ref_.current) {
                    const joinButton1 = ref_.current.querySelector('#join-now-button1')
                    const loginButton1 = ref_.current.querySelector('#login-button1')
                    const joinButton2 = ref_.current.querySelector('#join-now-button2')
                    const loginButton2 = ref_.current.querySelector('#login-button2')
                    const rewardDetails= ref_.current.querySelectorAll('#GHALogin > div.rewards-details > div.drawer')


                    if (joinButton1)
                        joinButton1.removeEventListener('click', handleJoinNowClick);

                    if (joinButton2)
                        joinButton2.removeEventListener('click', handleJoinNowClick);

                    if (loginButton1)
                        loginButton1.removeEventListener('click', handleLoginClick);

                    if (loginButton2)
                        loginButton2.removeEventListener('click', handleLoginClick);

                    if(rewardDetails && rewardDetails.length>0){
                        rewardDetails.forEach(div => {
                            div.removeEventListener('click', () => {
                                 rewardDetails.forEach(d => d.classList.remove('open'));
                                
                                 div.classList.add('open');
                            });
                        });
        
                    }
        
                }
            }

        }

    })


    useEffect(() => {

        scrollToTop();


    }, []);



    return (

        <>
            <header class="inner-pages w-footer subpages">
                <a class="button-back" onClick={props.handleGoBack}></a>
                <div class="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                </div>

            </header>
            {
                props.pageContent
                    ? <div  ref={ref_} dangerouslySetInnerHTML={{ __html: props.pageContent }}></div>
                :
                <>
                <div></div>
                        <Loader displayMsg={"Loading.."} showClose={true} close={() => props.setGoHome(true)} />
                </>
            }
            
{/* `
           <button onClick={()=>props.handleNext(true)}>join now</button>
           <button onClick={()=>props.handleNext(false)}>login in </button> */}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
        logo: state.store.home.currentDuration.brandingInfo
            ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
            : "",
    };
};

export default connect(mapStateToProps, {setGoHome, closeOrderPopUp, sendAnalytics })(
    withTranslation("translations")(Gha_WelcomePage)
);
